import * as React from "react";
import {
  AppBar,
  Logout,
  ToggleThemeButton,
  useCreatePath,
  useGetIdentity,
  UserMenu,
} from "react-admin";
import { Link } from "react-router-dom";
import {
  Box,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Typography,
  useMediaQuery,
  Theme,
} from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import { darkTheme, lightTheme } from "./theme";

const ConfigurationMenu = React.forwardRef((props, ref) => {
  const { identity } = useGetIdentity();
  const createPath = useCreatePath();

  return (
    <MenuItem
      component={Link}
      // @ts-ignore
      ref={ref}
      {...props}
      to={createPath({ resource: "User", id: identity?.id, type: "show" })}
    >
      <ListItemIcon>
        <SettingsIcon />
      </ListItemIcon>
      <ListItemText>Mi Cuenta</ListItemText>
    </MenuItem>
  );
});
const CustomUserMenu = () => (
  <UserMenu>
    <ConfigurationMenu />
    <Logout />
  </UserMenu>
);

const CustomAppBar = (props: any) => {
  const isLargeEnough = useMediaQuery<Theme>((theme) =>
    theme.breakpoints.up("sm")
  );
  return (
    <AppBar
      {...props}
      color="secondary"
      elevation={1}
      userMenu={<CustomUserMenu />}
    >
      <Typography
        variant="h6"
        color="inherit"
        sx={{
          flex: 1,
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          overflow: "hidden",
        }}
        id="react-admin-title"
      />
      {isLargeEnough && <img alt="Logo" src="/logo.png" height="41" />}
      {isLargeEnough && <Box component="span" sx={{ flex: 1 }} />}
      <ToggleThemeButton darkTheme={darkTheme} lightTheme={lightTheme} />
    </AppBar>
  );
};

export default CustomAppBar;
